module.exports = __webpack_public_path__ + "static/media/team-greg.a81eece9.jpg";